/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import './ApplyLoanViewModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import _ from 'lodash';
import { fonts, themes } from '../../../themes/themes';
import CardContentTile from '../../../components/CardContentTile/CardContentTile';
import EmiTile from '../../../components/EMITile/EmiTile';
import VerticalBarController from '../../../components/VerticalBar/VerticalBarController';
import { getAmount } from '../../../configs/utils';
import { baseDateFormatting } from '../../../helper';
import { DateField } from '../../../../components';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allLeaveTypes: any;
  callBackGetData: (data: any) => void;
  loanViewModalData: any;
  trans?: any;
}

const ApplyLoanViewModalPresenter = ({
  isModalOpen,
  closeModal,
  loanViewModalData,
  trans,
}: ModalProps) => {
  const handleSubmit = () => {
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="800px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Recurring Payment Details') }}
        closeModal={closeModal}
      />
      <Grid
        container
        style={{
          marginTop: '35px',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
        }}
      >
        <Grid item xs={5} className="left-grid_loan">
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              fontSize: fonts.title,
              color: themes.blackDefault,
              fontWeight: 'bold',
            }}
          >
            {trans('Recurring Payment Details')}
          </Typography>

          <CardContentTile
            tile_key={trans('Recurring Payment Type')}
            tile_value={loanViewModalData?.type?.name}
            is_bold={true}
          />

          <CardContentTile
            tile_key={trans('Issue Date')}
            tile_value={
              <DateField
                value={loanViewModalData?.start_date}
                format={baseDateFormatting}
              />
            }
          />
          <CardContentTile
            tile_key={trans('Duration')}
            tile_value={`${loanViewModalData?.duration} ${trans('Months')}`}
            is_bold={true}
          />
          <CardContentTile
            tile_key={trans('Remarks')}
            tile_value={
              loanViewModalData?.comment ? loanViewModalData?.comment : '--'
            }
            is_bold={true}
          />
        </Grid>
        <Box style={{ marginLeft: '1em' }} />
        <Grid item xs={4} className="left-grid_loan_view">
          {_.map(loanViewModalData?.emi, (data: any, index: number) => {
            return (
              <EmiTile
                tile_key={`${trans('EMI')} ${index + 1}`}
                is_bold={true}
                tile_value={data?.amount ? getAmount(data?.amount) : '--'}
                tile_date={data?.dueDate}
              />
            );
          })}
        </Grid>
        <Box style={{ marginRight: '1em' }} />
        <Grid item xs={3} className="tracking_apply_loan_view_modal">
          <Grid
            container
            style={{
              padding: '10px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {trans('Tracking Details')}
              </Typography>
            </Grid>
            <VerticalBarController
              instanceId={loanViewModalData?.workflow_instance?.id}
            />
          </Grid>
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
        isSubmitButton={false}
        isCancelButton={false}
        isCloseButton={true}
      />
    </CustomModal>
  );
};

export default ApplyLoanViewModalPresenter;
